import { useMemo } from "react";

import { useCurrentUser } from "@qualio/ui-components";
import { useQuery } from "react-query";

import { GlobalSearchAPI } from "../../api/globalSearch";

export type ProductOption = {
  id: string;
  label: string;
};

// Returns every product in the company regardless of status (draft, effective,
// retired). Deliberately distinct from useResourceLibraryQuickSearch, which is
// scoped to effective items only — hence the separate query key.
export const useProductQuickSearch = () => {
  const { companyId } = useCurrentUser();

  const { isLoading, isError, error, data } = useQuery({
    queryKey: ["PRODUCT_SEARCH", companyId],
    queryFn: () => GlobalSearchAPI.quickSearchProducts(companyId),
  });

  const products = useMemo(
    (): Array<ProductOption> =>
      (data?.results ?? []).map((product) => ({
        id: product.identifiers.qri,
        label: product.name,
      })),
    [data],
  );

  return { isLoading, isError, error, data: products };
};
